
import { IExportChartConfig, RISK_CHART_MODES, VIEW } from 'interfaces';
import GQMapProvider from 'components/GQMap/GQMapProvider';
import {
    HeatmapProvider,
} from 'components/Heatmap/HeatmapProvider';
import ChartDataProvider from 'components/GQChart/ChartDataProvider';
import { IChartData } from 'components/GQChart/chartInterfaces';
import { IPreloadedHeatmapApiData, IPreloadedMapApiData, IExportChartData } from '../exportInterfaces';

interface Props {
    chartConfig: IExportChartConfig,
    chartData: IExportChartData
}

const renderMap = (
    chartConfig: IExportChartConfig,
    chartData: IPreloadedMapApiData
) => {
    return (
        <GQMapProvider
            hideToolbar
            view={chartConfig.viewType}
            preloadedData={chartData}
        />
    );
};

const renderHeatmap = (
    chartConfig: IExportChartConfig,
    chartData: IPreloadedHeatmapApiData
) => {
    return (
        <HeatmapProvider
            disableActiveGroup
            disableToggle
            hideToolbar
            disableTooltip
            preloadedData={chartData}
        />
    );
};

const renderChart = (
    chartConfig: IExportChartConfig,
    chartData?: IChartData[]
) => {
    return (
        <>
            <div className="chart-container">
                <ChartDataProvider
                    showSlider={false}
                    activeView={chartConfig.viewType}
                    hasToolbar={false}
                    showVirtualToday={false}
                    showTooltip={false}
                    isExportComponent
                    preloadedData={chartData || []}
                    disableAutoLoad
                    showPulseData={
                        chartConfig.riskChartMode === RISK_CHART_MODES.PULSE ||
                        chartConfig.riskChartMode ===
                            RISK_CHART_MODES.RISK_AND_PULSE
                    }
                />
            </div>
        </>
    );
};

const ExportChartMainView = (
    { chartConfig, chartData }: Props
) => {
    switch (chartConfig.viewType) {
        case VIEW.COUNTRY_GRAPH:
        case VIEW.COUNTRY_GRAPH_SELECT_COUNTRY:
        case VIEW.WORLD_GRAPH:
        case VIEW.CONTINGENT_GRAPH:
            return renderChart(chartConfig, chartData as IChartData[]);
        case VIEW.HEATMAP:
            return renderHeatmap(
                chartConfig,
                chartData as IPreloadedHeatmapApiData
            );
        case VIEW.SORT_BY_RISK:
        case VIEW.SORT_BY_DELTA:
        case VIEW.SORT_BY_CONTINGENT_RISK:
        case VIEW.SORT_BY_CONTINGENT_DELTA:
        case VIEW.CONTINGENT:
            return renderMap(chartConfig, chartData as IPreloadedMapApiData);
        default:
            return null;
    }
};

export default ExportChartMainView;